import countryOptions from "./countries";
import stateOptions from "./states";
import degreeOptions from "./degree";
import majorOptions from "./major";
import jobFieldOptions from "./jobfield";
import uniNameOptions from "./uniName";

const currentYear = new Date().getFullYear();

const kvisYearOptions = [...Array(currentYear - 2018 + 1 + 3)].map(
  (val, idx) => {
    return {
      value: `${currentYear - idx + 3}`,
      label: `${currentYear - idx + 3} (Gen ${currentYear -
        2018 +
        1 +
        3 -
        idx})`
    };
  }
);

const yearOptions = [...Array(currentYear - 2015 + 1)].map((val, idx) => {
  return {
    value: `${currentYear - idx}`,
    label: `${currentYear - idx}`
  };
});

const futureYearOptions = [...Array(currentYear - 2015 + 1 + 10)].map(
  (val, idx) => {
    return {
      value: `${currentYear - idx + 10}`,
      label: `${currentYear - idx + 10}`
    };
  }
);

const getLabel = (options, value) => {
  if (!options || !value) return "";
  const res = options.find(option => option.value === value);
  return res ? res.label : "";
};

const getCountryStateLabel = (country, state) => {
  return {
    country: getLabel(countryOptions, country),
    state: getLabel(stateOptions[country], state)
  };
};

const bucketNum = 6;
const bucketSize = Math.ceil(26 / bucketNum);
const splitter = /[,;/() ]+/;

const hashText = text => {
  if (!text) return [];
  const words = text.toLowerCase().split(splitter);
  const res = [];
  words.forEach(word => {
    const id = ((word.charCodeAt(0) - 97) / bucketSize) >> 0;
    if (id >= 0 && id < bucketNum) res.push(id);
  });
  return res;
};

const hashOption = (options, value) => {
  const index = options.findIndex(item => item.value === value);
  if (index === -1) return [];
  const myBucketSize = Math.ceil(options.length / bucketNum);
  const id = (index / myBucketSize) >> 0;
  if (id >= 0 && id < bucketNum) return [id];
  return [];
};

const initializeBucket = (obj, prefix) => {
  for (let i = 0; i < bucketNum; i++) {
    obj[prefix + i] = false;
  }
};

const fields = [
  { name: "country", prefix: "c", options: countryOptions },
  { name: "uniName", prefix: "u", isText: true },
  { name: "degree", prefix: "d", options: degreeOptions },
  { name: "major", prefix: "m", isText: true },
  { name: "scholarship", prefix: "s", isText: true },
  { name: "jobTitle", prefix: "j", isText: true },
  { name: "employer", prefix: "e", isText: true },
  { name: "jobField", prefix: "f", options: jobFieldOptions },
  { name: "name", prefix: "n", isText: true }
];

const educationFields = [0, 1, 2, 3, 4];
const careerFields = [0, 5, 6, 7];

const initHash = {};
fields.forEach(field => {
  initializeBucket(initHash, field.prefix);
});

const calculateProfileUpdate = (profile, updateValue) => {
  const newProfile = { ...profile, ...updateValue, ...initHash };
  // name
  newProfile.name = `${newProfile.firstName} ${newProfile.lastName}`;
  hashText(newProfile.name).forEach(id => {
    newProfile[`n${id}`] = true;
  });

  if (newProfile.education) {
    newProfile.education.forEach(edu => {
      educationFields.forEach(fId => {
        const field = fields[fId];
        const res = field.isText
          ? hashText(edu[field.name])
          : hashOption(field.options, edu[field.name]);

        res.forEach(id => {
          newProfile[`${field.prefix}${id}`] = true;
        });
      });
    });
  }

  if (newProfile.career) {
    newProfile.career.forEach(job => {
      careerFields.forEach(fId => {
        const field = fields[fId];
        const res = field.isText
          ? hashText(job[field.name])
          : hashOption(field.options, job[field.name]);

        res.forEach(id => {
          newProfile[`${field.prefix}${id}`] = true;
        });
      });
    });
  }
  const updateField = {};
  Object.entries(newProfile).forEach(entry => {
    if (profile[entry[0]] !== entry[1]) {
      updateField[entry[0]] = entry[1];
    }
  });
  return updateField;
};

export {
  kvisYearOptions,
  yearOptions,
  futureYearOptions,
  countryOptions,
  degreeOptions,
  majorOptions,
  stateOptions,
  jobFieldOptions,
  uniNameOptions,
  getLabel,
  getCountryStateLabel,
  calculateProfileUpdate,
  hashOption,
  hashText,
  bucketNum,
  fields
};
